export default class Filter {

  constructor () {

    this.options = {
      el: 'form.js--filter',
      activeClass: 'js--init',
    };

    this.$el = $(this.options.el).not('.js--init');
    this.$body = $('body');

    return this;
  }


  init () {
    let _this = this;


    // Отправить форму фильта по изменению значений
    this.$body.on('change', this.options.el + ' input', function () {
      let $input = $(this);
      let $form = $input.parents('form');

      let param = $form.find("[name='srch[Param]']:checked").val() || 'all';

      $form.attr('action', $form.attr('action') + param + "/#filter-result").submit();
    });

  }


  render () {
    if (this.$el.length) {
      this.init();
    }
    return this;
  }

}
